// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .dropdown-menu {
      max-height: 200px;
      overflow-y: auto;
    }
    .dropdown-item:hover {
      background-color: #f8f9fa;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/shared/components/multi-select-dropdown/multi-select-dropdown.component.ts"],"names":[],"mappings":";IACI;MACE,iBAAiB;MACjB,gBAAgB;IAClB;IACA;MACE,yBAAyB;IAC3B","sourcesContent":["\n    .dropdown-menu {\n      max-height: 200px;\n      overflow-y: auto;\n    }\n    .dropdown-item:hover {\n      background-color: #f8f9fa;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
